export default __webpack_public_path__ + "static/laminas_8-e9d851d61b7b137358478f960ea55ef1.png";